module.exports = __webpack_public_path__ + "img/AIAgent-B.2ce7c03c.svg";